<div class="mobile-cart-footer">
  <div class="cart-footer-row d-flex justify-content-between">
    <div [innerHTML]="'cart.mobile.totalPrice' | translate"></div>
    <div>{{total | currencyFormat : currency}}</div>
  </div>

  <ng-container [ngSwitch]="deliveryType">
    <ng-container *ngSwitchCase="DELIVERY_OPTIONS.PICKUP">
      <div class="cart-footer-row d-flex justify-content-between">
        <div class="nowrap" [translate]="'common.delivery.pickUpLocation'"></div>

        <div class="cart-footer-info-col"
             (click)="onDeliveryEdit.emit()">
          {{ delivery?.outletName }}
        </div>

        <i class="icon-chevron-right"></i>
      </div>

      <div class="cart-footer-row d-flex justify-content-between"
           *ngIf="delivery?.date">
        <div class="nowrap" [translate]="'common.delivery.pickUpTime'"></div>

        <div class="cart-footer-info-col"
             (click)="onDeliveryEdit.emit()">
          {{delivery?.date | i18nDate : 'dddd D.'}}&nbsp;<span
          class="text-lowercase">{{delivery?.date | i18nDate : 'MMM'}}</span>
          {{delivery?.timeRange}}
        </div>

        <i class="icon-chevron-right"></i>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="DELIVERY_OPTIONS.DELIVERY">
      <div class="cart-footer-row d-flex justify-content-between">
        <div class="nowrap" [translate]="'common.delivery.deliverTo'"></div>

        <div class="cart-footer-info-col"
             (click)="onDeliveryEdit.emit()">
          {{delivery?.address}}, {{delivery?.postNumber}} {{delivery?.cityName}}
        </div>

        <i class="icon-chevron-right"></i>
      </div>

      <div class="cart-footer-row d-flex justify-content-between">
        <div class="nowrap" [translate]="'common.delivery.deliveryTime'"></div>

        <div class="cart-footer-info-col"
             (click)="onDeliveryEdit.emit()">
          {{delivery?.date | i18nDate : 'dddd D.'}}&nbsp;<span
          class="text-lowercase">{{delivery?.date | i18nDate : 'MMM'}}</span>
          {{delivery?.timeRange}}
        </div>

        <i class="icon-chevron-right"></i>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="DELIVERY_OPTIONS.MAIL">
      <div class="cart-footer-row d-flex justify-content-between">
        <div class="nowrap" [translate]="'common.delivery.sendTo'"></div>

        <div class="cart-footer-info-col"
             (click)="onDeliveryEdit.emit()">
          {{delivery?.address}}, {{delivery?.postNumber}} {{delivery?.cityName}}
        </div>

        <i class="icon-chevron-right"></i>
      </div>
    </ng-container>
  </ng-container>

  <div class="cart-footer-row border-0 d-flex justify-content-between">
    <div class="mobile-cart-footer-discount">

    </div>

    <div class="text-danger pointer"
         [translate]="'cart.mobile.clearCart'"
         (click)="onClear.emit()">Clear cart
    </div>
  </div>

  <div class="cart-footer-actions d-flex justify-content-between">
    <button class="btn btn-outline-primary shop-more-btn me-3"
            [translate]="'cart.mobile.shopMore'"
            (click)="onShopMore.emit()">Shop more
    </button>
    <button class="btn btn-primary w-100"
            [translate]="'cart.mobile.goToCheckout'"
            (click)="onCheckout.emit()">Go to checkout
    </button>
  </div>
</div>
